import React from "react";

// region TypeScript Interfaces
interface ColorBoxProps {
    color: string;
    width?: string;
    height?: string;
}
// endregion

export default function ColorBox(props: ColorBoxProps) {
    return (
        <div style={{
            backgroundColor: props.color,
            width: props.width ? props.width : "20px",
            height: props.height ? props.height : "20px"
        }}></div>
    );
}
